import { translate, translateFormatter, type RichTextFormatter } from '@/domains/core/localization/translate';
export const {
  goodToKnowHeader,
  productWarranty,
  productEan,
  returnPolicyWhenFree100days,
  returnPolicyWhenFreeNoDays,
  B2BFreeReturnsModalTitle,
  concreteGuaranteeLabel,
  concreteGuaranteeHeader
} = translate({
  "goodToKnowHeader": "Good to know",
  "productWarranty": "Warranty",
  "productEan": "EAN",
  "returnPolicyWhenFree100days": "Free return within 100 days",
  "returnPolicyWhenFreeNoDays": "Free returns",
  "B2BFreeReturnsModalTitle": "Si vous changez d\u2019avis, les retours sont gratuits !",
  "concreteGuaranteeLabel": "Concrete Guarantee Protection",
  "concreteGuaranteeHeader": "The Concrete Guarantee, buyer protection by ManoMano."
});
export const concreteGuaranteeContent = translateFormatter<{
  strong: RichTextFormatter;
  br: RichTextFormatter;
  a: RichTextFormatter;
}>([{
  "type": 8,
  "value": "strong",
  "children": [{
    "type": 0,
    "value": "Order with confidence!"
  }]
}, {
  "type": 0,
  "value": " At ManoMano, we protect each of your purchases. If you open a claim with one of our merchant partners and no satisfactory solution is found, we activate our Concrete Guarantee procedure. Our Customer Service then takes over to assist you until the issue is resolved."
}, {
  "type": 8,
  "value": "br",
  "children": []
}, {
  "type": 0,
  "value": "Discover all the details on "
}, {
  "type": 8,
  "value": "a",
  "children": [{
    "type": 0,
    "value": "our dedicated page"
  }]
}, {
  "type": 0,
  "value": "."
}], undefined, undefined, "en");
export const returnPolicyWhenFree = translateFormatter<{
  days: number;
}>([{
  "type": 0,
  "value": "Free return within "
}, {
  "type": 6,
  "value": "days",
  "options": {
    "=1": {
      "value": [{
        "type": 0,
        "value": "1 day"
      }]
    },
    "other": {
      "value": [{
        "type": 7
      }, {
        "type": 0,
        "value": " days"
      }]
    }
  },
  "offset": 0,
  "pluralType": "cardinal"
}], undefined, undefined, "en");
export const returnPolicyWhenNotFree = translateFormatter<{
  days: number;
}>([{
  "type": 0,
  "value": "Return within "
}, {
  "type": 6,
  "value": "days",
  "options": {
    "=1": {
      "value": [{
        "type": 0,
        "value": "1 day"
      }]
    },
    "other": {
      "value": [{
        "type": 7
      }, {
        "type": 0,
        "value": " days"
      }]
    }
  },
  "offset": 0,
  "pluralType": "cardinal"
}], undefined, undefined, "en");
export const B2BFreeReturnsModalContent = translateFormatter<{
  withdrawalDays: number;
  reimbursementDays: number;
  strong: RichTextFormatter;
  br: RichTextFormatter;
}>([{
  "type": 0,
  "value": "Vous avez "
}, {
  "type": 6,
  "value": "withdrawalDays",
  "options": {
    "=1": {
      "value": [{
        "type": 0,
        "value": "1 jour"
      }]
    },
    "other": {
      "value": [{
        "type": 7
      }, {
        "type": 0,
        "value": " jours"
      }]
    }
  },
  "offset": 0,
  "pluralType": "cardinal"
}, {
  "type": 0,
  "value": " minimum pour retourner vos produits. Vous serez rembours\xE9 au plus tard "
}, {
  "type": 6,
  "value": "reimbursementDays",
  "options": {
    "=1": {
      "value": [{
        "type": 0,
        "value": "1 jour"
      }]
    },
    "other": {
      "value": [{
        "type": 7
      }, {
        "type": 0,
        "value": " jours"
      }]
    }
  },
  "offset": 0,
  "pluralType": "cardinal"
}, {
  "type": 0,
  "value": " apr\xE8s la r\xE9ception par le marchand de votre d\xE9cision de vous r\xE9tracter. Veuillez noter que le marchand peut suspendre votre remboursement jusqu\u2019\xE0 r\xE9ception des produits ou de la preuve de renvoi des produits retourn\xE9s, la date la plus proche \xE9tant retenue. Si vous disposez toujours de l\u2019emballage d\u2019origine, merci de l\u2019utiliser pour renvoyer votre produit. "
}, {
  "type": 8,
  "value": "br",
  "children": []
}, {
  "type": 8,
  "value": "br",
  "children": []
}, {
  "type": 8,
  "value": "strong",
  "children": [{
    "type": 0,
    "value": "Comment retourner un produit?"
  }]
}, {
  "type": 8,
  "value": "br",
  "children": []
}, {
  "type": 0,
  "value": "C\u2019est facile ! Rendez-vous dans \u201CMes commandes\u201D et cliquez sur \u201Cretourner mon produit\u201D pour avoir les instructions de retour."
}], undefined, undefined, "en");
const productTranslations: {
  [key: string]: string;
} = {
  warranty: productWarranty,
  ean: productEan
};
export const translateAttributeName = (name: string): string => productTranslations[name] || name;
export const {
  claimExpress
} = translate({
  "claimExpress": "Delivery within 24 to 48 hours"
});